import React from 'react';
const PainSection = () => {
  return <div className="w-full bg-gray-600 text-white py-16 px-4" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <h2 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-111">
          Koleżanki, które już dawno mnie wyprzedziły
        </h2>
        <p className="text-lg mb-6" data-id="element-112">
          Następnego dnia w pracy Anka opowiadała o kursie mindfulness, który
          zaczęła. Beata chwaliła się, że zapisała się na włoski – "bo zawsze
          marzyłam o Toskanii". Nawet Jolka, wiecznie zajęta Jolka, mówiła o
          planach na własny biznes.
        </p>
        <p className="text-lg mb-6" data-id="element-113">"A ty, Kasia? Co u ciebie?" – zapytały.</p>
        <p className="text-lg mb-6" data-id="element-114">
          Milczałam. Co miałam powiedzieć? Że moje życie to niekończący się
          maraton między pracą, mamą, dziećmi i znowu mamą? Że nie pamiętam,
          kiedy ostatnio pomyślałam o czymś swoim?
        </p>
        <p className="text-lg mb-6" data-id="element-115">
          "No wiesz... tak jakoś..." – wymamrotałam.
        </p>
        <p className="text-lg mb-6" data-id="element-116">
          Spojrzały po sobie tym wzrokiem. Znasz ten wzrok? Taki pełen
          współczucia i ulgi jednocześnie. Ulgi, że to nie one.
        </p>
        <div className="bg-gray-700 p-6 rounded-lg my-8 border-l-4 border-red-400" data-id="element-117">
          <p className="text-lg italic" data-id="element-118">
            Ile razy czułaś ten wstyd, że nie masz nic ciekawego do powiedzenia
            o sobie?
          </p>
          <p className="text-lg italic mt-4" data-id="element-119">
            Że gdy pytają o twoje plany, jedyne co przychodzi ci do głowy to
            lista obowiązków wobec innych?
          </p>
        </div>
        <h3 className="text-xl md:text-2xl font-bold mt-12 mb-6" data-id="element-120">
          Wieczór, który wszystko zmienił
        </h3>
        <p className="text-lg mb-6" data-id="element-121">
          Wróciłam do domu. Mama leżała przed telewizorem, ale jak tylko mnie
          zobaczyła, zaczęła:
        </p>
        <p className="text-lg mb-6" data-id="element-122">
          "Gdzie byłaś tak długo? Myślałam, że coś ci się stało! A co z kolacją?
          I musisz mi pomóc się umyć, bo sama nie dam rady..."
        </p>
        <p className="text-lg mb-6" data-id="element-123">
          Syn pakował się w swoim pokoju. Córka rozmawiała przez telefon o
          jakichś mieszkaniach do wynajęcia.
        </p>
        <p className="text-lg mb-6" data-id="element-124">
          A ja stałam pośrodku tego wszystkiego i nagle poczułam, jakbym się
          rozpadała.
        </p>
        <p className="text-lg mb-6" data-id="element-125">
          Nie wiedziałam, kim jestem. Nie wiedziałam, czego chcę. Nie miałam
          żadnego planu.
        </p>
        <p className="text-lg mb-6" data-id="element-126">
          Byłam tylko... funkcją. Matką. Córką. Tą, która załatwia, organizuje,
          dba.
        </p>
        <p className="text-2xl font-bold text-red-300 my-8 text-center" data-id="element-127">
          Ale kim ja, kurwa, jestem NAPRAWDĘ?
        </p>
        <p className="text-lg mb-6" data-id="element-128">
          W tej chwili poczułam, że jeśli tak dalej pójdzie, za rok, za pięć
          lat, nadal będę stała w tym samym miejscu. Wszyscy dookoła będą żyli
          swoimi życiami, a ja będę tylko... obsługiwała ich potrzeby.
        </p>
      </div>
    </div>;
};
export default PainSection;